<div class="card" [formGroup]="form">
  <div class="card-header">*NOA Designated Subrecipient Key Personnel</div>

  <div class="card-block">
    <div style="display: flex; align-items: center; width: 26vw">
      <subs-yes-no
        class="clr-col"
        label="Key Personnel"
        controlName="hasKeyPersonnel"
        [tooltip]="keyPersonnelTooltip"
      >
      </subs-yes-no>
      <ng-template #keyPersonnelTooltip>
        <a
          role="tooltip"
          aria-haspopup="true"
          class="tooltip tooltip-md tooltip-bottom-right"
        >
          <clr-icon shape="info-circle" size="22"></clr-icon>
          <span class="tooltip-content"
            >Does this subrecipient have NOA designated Key Personnel?</span
          >
        </a>
      </ng-template>
    </div>
    <div
      *ngFor="
        let person of this.form.controls['fullNames'].controls;
        let i = index
      "
      style="
        display: flex;
        justify-content: space-between;
        align-items: baseline;
      "
      [formGroup]="person"
    >
      <subs-input
        style="width: 95%"
        label="Full name"
        [labelWidth]="'10%'"
        controlName="fullName"
      ></subs-input>
      <button
        type="button"
        class="btn btn-icon"
        (click)="removeKeyPersonnel(i)"
        style="border: none"
      >
        <clr-icon shape="remove" size="20"></clr-icon>
      </button>
    </div>

    <div style="display: flex; justify-content: flex-end; margin-top: 2%">
      <button type="button" class="btn btn-outline" (click)="addKeyPersonnel()">
        Add Key Personnel
      </button>
    </div>
  </div>
</div>
